export interface MaderaReportLink {
    url: string;
}

export enum ReportType {
    PARCEL = "PARCEL",
    FARM_UNIT = "FARM_UNIT",
    ACCOUNT = "ACCOUNT",
}

export interface GetMaderaReportOptions {
    companyId: string;
    reportType?: ReportType;
    farmUnit?: string;
    parcel?: string;
    year?: number;
    farmName?: string;
}
